import angular from 'angular';

class EmptySectionController {
  static $inject = ['$element'];

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-empty-section');
  }
}

export const EmptySectionComponentModule = angular
  .module('acme.common.component.emptySection', [])
  .component('acmeEmptySection', {
    templateUrl: 'common/components/empty-section/empty-section.component.tpl.html',
    controller: EmptySectionController,
    transclude: true,
    bindings: {},
  }).name;
